import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const Row = ({ row, isSelected, ...props }) => <>
  <TableCell size={'small'}><TextCell value={_.get(row, 'commercial_package.name_translated')} /></TableCell>
  <TableCell size={'small'}><TextCell value={_.get(row, 'noshow.name')} /></TableCell>
</>

export default React.memo(Row)
